import React, { useMemo } from "react";
import PropTypes from "prop-types";

export const Calculator = ({ type }) => {
  const src = useMemo(() => `/${type}Calculator.html`, [type]);

  return <iframe src={src} className="dt-calculator" />;
};

Calculator.propTypes = {
  type: PropTypes.oneOf([
    "CompareLoan",
    "InvestmentProperty",
    "MortgageApr",
    "MortgageArmvsFixed",
    "MortgageLoan",
    "MortgageConsolidate",
    "MortgageMax",
    "MortgagePoints",
    "MortgageQualifier",
    "MortgageRefinanceLoan",
    "MortgageRentvsBuy",
    "MortgageTaxes",
    "PersonalDebtRatio",
    "ShouldIRefi",
  ]).isRequired,
};
